import Highcharts from 'highcharts';

export const highchatsTheme = (colors: Array<string>, labelColor: string) => {
  Highcharts.theme = {
    colors, // : ['#344054', '#E5E5F1', '#667085', '#98A2B3', '#E4E7EC', '#27D4D4', '#17A2B8'],
    chart: {
      style: {
        fontFamily: 'Gilroy-Regular',
        color: '#475467',
      },
      backgroundColor: 'transparent',
    },
    title: {
      style: {
        color: colors[0], //'#34495e',
        fontWeight: '700',
        fontSize: '30px',
      },
    },
    subtitle: {
      style: {
        color: colors[0], //'#34495e',
        fontSize: '11px',
        fontWeight: '500',
        textTransform: 'uppercase',
      },
    },

    tooltip: {
      backgroundColor: '#101828',
      borderRadius: 10,
      enabled: true,
      outside: true,
      style: {
        color: 'white',
        zIndex: 100,
      },
    },
    legend: {
      itemStyle: {
        color: labelColor,
      },
      itemHoverStyle: {
        color: labelColor,
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        states: {
          hover: {
            enabled: true,
          },
        },
      },
      pie: {
        // center: ['35%', '50%'],
        // size: '20%',

        //innerSize: '10%',
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false,
        },
        point: {
          events: {
            click: function (e: Event) {
              // console.log(new Date().toLocaleString() + '  ➤  e =>', e);
              // console.log(new Date().toLocaleString() + '  ➤  this.options =>', this.options);
            },
            legendItemClick: () => false,
          },
        },
        showInLegend: false,
        borderWidth: 0,
        // colors: [
        //   // '#C752F5',
        //   // '#61D8FF',
        //   // '#8280f9',
        //   '#fa0060',
        //   '#CFCFE8',
        //   '#321845',
        //   '#FF8080',
        //   '#c9cbcf',
        //   '#7CB5EC',
        //   '#434348',
        // ],
      },
    },
    xAxis: {
      title: {
        style: {
          color: labelColor,
        },
      },
      labels: {
        style: {
          color: labelColor,
        },
      },
    },
    yAxis: {
      title: {
        style: {
          color: labelColor,
        },
      },
      labels: {
        style: {
          color: labelColor,
        },
      },
    },
  };

  // Apply the theme
  Highcharts.setOptions(Highcharts.theme);
};
